import React from 'react';

type PageHeaderProps = {
  children?: React.ReactNode;
  title: string;
}

export default function NewPageHeader({ children, title }: PageHeaderProps) {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center my-4">
        <h4>{title}</h4>
        {children}
      </div>
    </div>
  );
}
